export type LocalizedWords = {
	[key: string]: {
		[key: string]: string;
	};
};

export const localizedWords: LocalizedWords = {
	'en-AU': {
		travel: 'Travel around Australia',
		origin: 'Australian',
		resident: 'an Australian',
		taxOffice: 'ATO',
		dateFormat: 'dd/MM/yyyy'
	},
	'en-US': {
		travel: 'Travel around the US',
		origin: 'US',
		resident: 'a US',
		taxOffice: 'IRS',
		dateFormat: 'MM/dd/yyyy'
	}
};
